const stripeAccountStatusEnum = {
  COMPLETE: 'Complete',
  RESTRICTED: 'Restricted',
  ERROR: 'Error',
  NOT_CREATED: 'Not created',
  DISCONNECTED: 'Disconnected',
}

export default stripeAccountStatusEnum
